module.exports = __webpack_public_path__ + "static/media/greggo-2.aa054a6e.jpg";